import React from "react";
import { GirlInCircle } from "../../assets/images";

type ThirdSplashScreenProps = {
  handleContinue: () => void;
};
const ThirdSplashScreen: React.FC<ThirdSplashScreenProps> = ({
  handleContinue,
}) => {
  return (
    <div className="flex h-full items-center bg-midGreen justify-center w-full flex-col relative">
      <div className="px-7 h-[40%] w-full font-BRFirma pt-14">
        <div className="text-white text-[25px]">Share your experience</div>
        <div className=" w-full">
          <p className="text-[15px] font-medium text-white break-words whitespace-pre-line text-pretty mt-2">
            The App allows you to share your routes, upload images and leave
            comments.
          </p>
          <p className="text-[15px] font-medium text-white break-words whitespace-pre-line text-pretty">
            Interact with other users and be a part of the community.
          </p>
          <div
            className="items-center mt-3 cursor-pointer bg-white flex justify-center text-center font-Poppins font-medium text-lg w-[335px] h-[50px] text-midGreen rounded-2xl"
            onClick={handleContinue}
          >
            Continue
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center h-[60%] z-10 pt-6">
        <img
          src={GirlInCircle}
          alt=""
          className="h-full w-full object-cover object-center"
        />
      </div>
    </div>
  );
};

export default ThirdSplashScreen;
